import { useEffect, useState, useRef, useContext, createContext } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import ReactAutocomplete from "react-google-autocomplete"
import axios from "axios";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Australia/Melbourne')

import styles from "../Hub/Hub.module.css"
import rstyles from "../Register/Register.module.css"
import guestii_gif from '../../assets/images/guestii_gif.gif'


export const UploadImgContainer = ({ handleForm, formData }) => {
	const [isLoading, setIsLoading] = useState(false)
	const [validationError, setValidationError] = useState(null)
	const fileInputRef = useRef(null)


	const checkFileSize = (size) => {
		if (size > 10 * 1024 * 1024) {
			return true
		}

		return false;
	}

	const handleUploadFile = async (input) => {
		const file = input.target.files[0]

		if (file) {
			setValidationError(null)
			setIsLoading(true)

			try {
				const fileTooBig = checkFileSize(file.size)

				if (fileTooBig) {
					setValidationError("File too big. Maximum upload: 10mb")
					setIsLoading(false);
					return false;
				}

				const fileData = new FormData();
				fileData.append('file', file);

				await axios.post(`/api/hub/check-file-safety`, fileData)
			} catch(e) {
				console.log(e)
				setValidationError(e.response.data.error)
				setIsLoading(false);
				return false;
			}

			handleForm("set", "banner", input)
			setValidationError(null)
			setIsLoading(false)
		}
	}

	return (
		<>
			<button className={styles.event_banner_upload_btn} disabled={isLoading} onClick={() => fileInputRef.current.click()}>
				{isLoading
					? <img src={guestii_gif} className={styles.logo_gif}/>
					:
						<>
							{(validationError)
								?
									<p className={`${styles.s2}`}>{validationError}</p>
								:
									<>
										{(formData && formData.banner)
											?
												<>
													<i className={`fa-solid fa-check ${styles.m3}`}></i>
													<p className={`${styles.s2}`}>Banner Uploaded</p>
												</>
											:
												<>
													<i className={`fa-solid fa-image ${styles.m3}`}></i>
													<p className={`${styles.s2}`}>Event Banner Image</p>
												</>
										}
									</>
							}
						</>
				}
			</button>

			<input
				type="file"
				ref={fileInputRef}
				style={{ display: 'none' }}
				accept=".png, .jpg, .jpeg"
				onChange={(input) => handleUploadFile(input)}
			/>
		</>
	)
}

export const MovingTextContainer = ({ label, icon, handleForm, formData, classData=null, secondary=false, dashboard=false, register=false, password=false, isLoading=false, autofill=false, keyField=false }) => {
	const [showingLabel, setShowingLabel] = useState(true)
	const labelFormatted = keyField ? keyField : label.replaceAll(' ', '_').toLowerCase()

	const classLocaiton = classData ? classData.location : "styles"
	const className = classData ? classData.name : "nevent_input_container"

	const handleAnimationStart = (event) => {
		if (event.animationName === 'autofill') {
			setShowingLabel(false)
		}
	};

	return (
		<div className={`${classLocaiton === "rstyles" ? rstyles[className] : styles[className]} ${secondary && rstyles.second_input} ${dashboard && styles.invertColours}`}>
			<div
				className={`${styles.movingLabel} ${dashboard && styles.invertColoursInput} ${register && styles.changeColoursInput}`}
		        style={{
		          	top: showingLabel && !formData[labelFormatted] ? "50%" : "-10px",
		          	transform: showingLabel && !formData[labelFormatted] ? "translate(0, -50%)" : "",
		          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, background-color 0.3s ease",
		          	backgroundColor: register ? "#ffffff" : (dashboard) ? "#161824" : !(showingLabel && !formData[labelFormatted]) && "#01000D"
		        }}
			>
				<i className={`${icon} ${styles.s2}`}></i>
				<p className={`${styles.s2}`}>{label}</p>
			</div>

			<input
				disabled={isLoading}
				// ref={inputRef}
				onAnimationStart={handleAnimationStart}
				type={password ? "password" : "text"}
				className={`${styles.s2} ${autofill && "autofilled_input"}`}
				onFocus={() => setShowingLabel(false)}
				onBlur={() => setShowingLabel(true)}
				onClick={() => setShowingLabel(false)}
				onChange={(input) => handleForm("set", keyField ? keyField : label, input, keyField ? true : false)}
				value={(formData && formData[labelFormatted] && formData[labelFormatted] !== false) ? formData[labelFormatted] : ""}
			/>
		</div>
	)
}


export const MovingDateTimeContainer = ({ label, time=false, handleForm, formData }) => {
	const [showingLabel, setShowingLabel] = useState(true)
	const labelFormatted = label.replaceAll(' ', '_').toLowerCase()

	return (
		<div className={`${styles.nevent_input_container}`}>
			<div
				className={styles.movingLabel}
		        style={{
		          	top: showingLabel && !formData[labelFormatted] ? "50%" : "-10px",
		          	transform: showingLabel && !formData[labelFormatted] ? "translate(0, -50%)" : "",
		          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, background-color 0.3s ease",
		          	backgroundColor: !(showingLabel && !formData[labelFormatted]) && "#01000D"
		        }}
			>
				<i className={`fa-solid fa-calendar-days ${styles.s2}`}></i>
				<p className={styles.s2}>{label}</p>
			</div>

			<LocalizationProvider dateAdapter={AdapterDayjs}>
			    <DateTimePicker
			        className={styles.overridebg}
					onChange={(input) => handleForm("set", label, input)}
					value={formData && formData[labelFormatted] && dayjs(formData[labelFormatted])}
					format="DD/MM/YYYY HH:mm"
					onOpen={() => setShowingLabel(false)}
					onClose={() => setShowingLabel(true)}
					slotProps={{ 
						textField: { 
							placeholder: '',
				            onFocus: (e) => {
				              setShowingLabel(false)
				            },
				            onBlur: (e) => {
				              setShowingLabel(true)
				            },
						}
					}}
			    />
			</LocalizationProvider>
		</div>
	)
}

export const MovingTimeContainer = ({ label, time=false, handleForm, formData }) => {
	const [showingLabel, setShowingLabel] = useState(true)
	const labelFormatted = label.replaceAll(' ', '_').toLowerCase()

	return (
		<div className={`${styles.nevent_input_container}`}>
			<div
				className={styles.movingLabel}
		        style={{
		          	top: showingLabel && !formData[labelFormatted] ? "50%" : "-10px",
		          	transform: showingLabel && !formData[labelFormatted] ? "translate(0, -50%)" : "",
		          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, background-color 0.3s ease",
		          	backgroundColor: !(showingLabel && !formData[labelFormatted]) && "#01000D"
		        }}
			>
				<i className={`fa-solid fa-clock ${styles.s2}`}></i>
				<p className={styles.s2}>{label}</p>
			</div>

			<LocalizationProvider dateAdapter={AdapterDayjs}>
			    <TimePicker
			        className={styles.overridebg}
					onChange={(input) => handleForm("set", label, input)}
					value={formData && formData[labelFormatted] && dayjs(formData[labelFormatted])}
					format="HH:mm"
					onOpen={() => setShowingLabel(false)}
					onClose={() => setShowingLabel(true)}
					slotProps={{ 
						textField: { 
							placeholder: '',
				            onFocus: (e) => {
				              setShowingLabel(false)
				            },
				            onBlur: (e) => {
				              setShowingLabel(true)
				            },
						}
					}}
			    />
			</LocalizationProvider>
		</div>
	)
}

export const MovingAutocompleteContainer = ({ label, icon, handleForm, newAddress }) => {
	const [showingLabel, setShowingLabel] = useState(true)
	const labelFormatted = label.replaceAll(' ', '_').toLowerCase()

	return (
		<div className={styles.nevent_input_container}>
			<div
				className={styles.movingLabel}
		        style={{
		          	top: showingLabel && !newAddress ? "50%" : "-10px",
		          	transform: showingLabel && !newAddress ? "translate(0, -50%)" : "",
		          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, background-color 0.3s ease",
		          	backgroundColor: !(showingLabel && !newAddress) && "#01000D"
		        }}
			>
				<i className={`${icon} ${styles.s2}`}></i>
				<p className={styles.s2}>{label}</p>
			</div>

			<ReactAutocomplete
				apiKey="AIzaSyAPGR-rJOJE8h4YwVPlgJQjnUEzJcOQqb4"
				onPlaceSelected={(place) => handleForm("set_address", null, place)}
				options={{types: ["establishment"]}}
				className={styles.s2}
				onFocus={() => setShowingLabel(false)}
				onBlur={() => setShowingLabel(true)}
				placeholder=""
				defaultValue={newAddress && newAddress.formatted_address}
			/>
		</div>
	)
}


export const MovingTagContainer = ({ label, icon, handleForm, formData, showLabel=true, bottom=true, border=false }) => {
	return (
		<div style={{width: '100%', color: '#ffffff'}}>
			<CreatableSelect
				isMulti={true}
				options={["VIP", "CREW", "MEDIA", "STAFF", "GA"].map(item => { return { label: item, value: item } })}
				closeMenuOnSelect={false}
				styles={{
					input: (styles) => ({ ...styles, color: '#ffffff !important' }),
					control: (baseStyles, state) => ({
						...baseStyles,
						backgroundColor: "#01000D !important",
						boxShadow: 'none !important',
						color: "#ffffff !important",
					   '&:hover': {
					       	borderColor: border ? '#449dd1' : '#01000D11 !important'
					    },
					    borderWidth: border ? 2 : 1,
					    borderRadius: border ? '8px' : '4px',
						borderColor: border ? '#449dd1' : '#01000D',
					}),
				}}
				onChange={(selected) => handleForm("set", label, selected)}
				value={formData["tags"]}
			/>
		</div>
	)
}

export const MovingTypeContainer = ({ label, icon, handleForm, formData, showLabel=true, bottom=true, border=false }) => {
	return (
		<div style={{width: '100%', color: '#ffffff'}}>
			<Select
				options={["FREE", "PAY"].map(item => { return { label: item, value: item } })}
				closeMenuOnSelect={true}
				styles={{
					input: (styles) => ({ ...styles, color: '#ffffff !important' }),
					control: (baseStyles, state) => ({
						...baseStyles,
						backgroundColor: "#01000D !important",
						boxShadow: 'none !important',
						color: "#ffffff !important",
					   	'&:hover': {
					       	borderColor: border ? '#449dd1' : '#01000D11 !important'
					    },
					    borderWidth: border ? 2 : 1,
					    borderRadius: border ? '8px' : '4px',
						borderColor: border ? '#449dd1' : '#01000D',
					}),
				  	singleValue: (base) => ({
					    ...base,
					    color: '#ffffff',
				 	}),
				}}
				onChange={(selected) => handleForm("set", label, selected)}
				value={formData["type"]}
			/>
		</div>
	)
}

export const MovingPromoterContainer = ({ label, icon, handleForm, formData, showLabel=true, bottom=true, border=false, promoters }) => {
	return (
		<div style={{width: '100%', color: '#ffffff'}}>
			<Select
				options={promoters}
				closeMenuOnSelect={true}
				styles={{
					input: (styles) => ({ ...styles, color: '#ffffff !important' }),
					control: (baseStyles, state) => ({
						...baseStyles,
						backgroundColor: "#01000D !important",
						boxShadow: 'none !important',
						color: "#ffffff !important",
					   	'&:hover': {
					       	borderColor: border ? '#449dd1' : '#01000D11 !important'
					    },
					    borderWidth: border ? 2 : 1,
					    borderRadius: border ? '8px' : '4px',
						borderColor: border ? '#449dd1' : '#01000D',
					}),
				  	singleValue: (base) => ({
					    ...base,
					    color: '#ffffff',
				 	}),
				}}
				onChange={(selected) => handleForm("set", label, selected)}
				value={formData["promoter"]}
			/>
		</div>
	)
}

export const MovingTextCostContainer = ({ label, icon, handleForm, formData, classData=null, secondary=false, dashboard=false, register=false, password=false, isLoading=false, autofill=false, keyField=false }) => {
	const [showingLabel, setShowingLabel] = useState(true)
	const labelFormatted = keyField ? keyField : label.replaceAll(' ', '_').toLowerCase()

	const classLocaiton = classData ? classData.location : "styles"
	const className = classData ? classData.name : "nevent_input_container_cost"

	const handleAnimationStart = (event) => {
		if (event.animationName === 'autofill') {
			setShowingLabel(false)
		}
	};

	return (
		<div className={`${classLocaiton === "rstyles" ? rstyles[className] : styles[className]} ${secondary && rstyles.second_input} ${dashboard && styles.invertColours}`}>
			<div
				className={`${styles.movingLabel} ${dashboard && styles.invertColoursInput} ${register && styles.changeColoursInput}`}
		        style={{
		          	top: showingLabel && !formData[labelFormatted] ? "50%" : "-10px",
		          	transform: showingLabel && !formData[labelFormatted] ? "translate(0, -50%)" : "",
		          	transition: "top 0.3s ease, left 0.3s ease, transform 0.3s ease, background-color 0.3s ease",
		          	backgroundColor: register ? "#ffffff" : (dashboard) ? "#161824" : !(showingLabel && !formData[labelFormatted]) && "#01000D"
		        }}
			>
				<i className={`${icon} ${styles.s2}`}></i>
				<p className={`${styles.s2}`}>{label}</p>
			</div>

			<input
				disabled={isLoading}
				// ref={inputRef}
				onAnimationStart={handleAnimationStart}
				type={password ? "password" : "text"}
				className={`${styles.s2} ${autofill && "autofilled_input"}`}
				onFocus={() => setShowingLabel(false)}
				onBlur={() => setShowingLabel(true)}
				onClick={() => setShowingLabel(false)}
				onChange={(input) => handleForm("set", keyField ? keyField : label, input, keyField ? true : false)}
				value={(formData && formData[labelFormatted] && formData[labelFormatted] !== false) ? formData[labelFormatted] : ""}
			/>
		</div>
	)
}